import { render, staticRenderFns } from "./SelectableWizardCard.vue?vue&type=template&id=426631a0&scoped=true&"
import script from "./SelectableWizardCard.vue?vue&type=script&lang=js&"
export * from "./SelectableWizardCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectableWizardCard.vue?vue&type=style&index=0&id=426631a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426631a0",
  null
  
)

export default component.exports